import { AppConstants } from 'src/constants/constants';
import { Injectable } from '@angular/core';
import { fhirR4 } from '@smile-cdr/fhirts';

@Injectable({
  providedIn: 'root'
})
export class ClinicalAdapterService {

  getClinicalValueFromEntryValue(observationCode: string, value: string): string {
    let retVal = null;
    switch (observationCode) {
      case AppConstants.RACE_OBSERVATION_CODE:
        retVal = this.convertEntryValuesToClinicalValuesForRace(value);
        break;
      case AppConstants.DELAY_REASON_OBSERVATION_CODE:
        retVal = this.convertEntryValuesToClinicalValuesForDelayReason(value);
        break;
      default:
        retVal = value;
    }
    return retVal;
  }

  getEntryValueFromClinicalValue(observationCode: string, value: string): string {
    let retVal = null;
    switch (observationCode) {
      case AppConstants.RACE_OBSERVATION_CODE:
        retVal = this.convertClinicalValuesToEntryValuesForRace(value);
        break;
      case AppConstants.DELAY_REASON_OBSERVATION_CODE:
        retVal = this.convertClinicalValuesToEntryValuesForDelayReason(value);
        break;
      default:
        retVal = value;
    }
    return retVal;
  }

  convertEntryValuesToClinicalValuesForDelayReason(value: string): string {
    let retVal = null;
    switch (value) {
      case AppConstants.DELAY_REASON_RESOURCING:
        retVal = AppConstants.DELAY_REASON_RESOURCING_CLINICAL_VALUE;
        break;
      case AppConstants.DELAY_REASON_URGENT_PATIENT:
        retVal = AppConstants.DELAY_REASON_URGENT_PATIENT_CLINICAL_VALUE;
        break;
      case AppConstants.DELAY_REASON_EQUIPMENT_FAILURE:
        retVal = AppConstants.DELAY_REASON_EQUIPMENT_FAILURE_CLINICAL_VALUE;
        break;
      case AppConstants.DELAY_REASON_OTHER:
        retVal = AppConstants.DELAY_REASON_OTHER_CLINICAL_VALUE;
        break;
    }
    return retVal;
  }

  convertClinicalValuesToEntryValuesForDelayReason(value: string): string {
    let retVal = null;
    switch (value) {
      case AppConstants.DELAY_REASON_RESOURCING_CLINICAL_VALUE:
        retVal = AppConstants.DELAY_REASON_RESOURCING;
        break;
      case AppConstants.DELAY_REASON_URGENT_PATIENT_CLINICAL_VALUE:
        retVal = AppConstants.DELAY_REASON_URGENT_PATIENT;
        break;
      case AppConstants.DELAY_REASON_EQUIPMENT_FAILURE_CLINICAL_VALUE:
        retVal = AppConstants.DELAY_REASON_EQUIPMENT_FAILURE;
        break;
      case AppConstants.DELAY_REASON_OTHER_CLINICAL_VALUE:
        retVal = AppConstants.DELAY_REASON_OTHER;
        break;
    }
    return retVal;
  }

  convertEntryValuesToClinicalValuesForRace(value: string): string {
    let retVal = null;
    switch (value) {
      case AppConstants.RACE_BLACK:
        retVal = AppConstants.RACE_BLACK_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_EAST_SOUTHEAST_ASIAN:
        retVal = AppConstants.RACE_EAST_SOUTHEAST_ASIAN_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_INDIGENOUS:
        retVal = AppConstants.RACE_INDIGENOUS_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_LATINO:
        retVal = AppConstants.RACE_LATINO_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_MIDDLE_EASTERN:
        retVal = AppConstants.RACE_MIDDLE_EASTERN_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_SOUTH_ASIAN:
        retVal = AppConstants.RACE_SOUTH_ASIAN_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_WHITE:
        retVal = AppConstants.RACE_WHITE_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_OTHER:
        retVal = AppConstants.RACE_OTHER_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_PREFER_NOT_TO_ANSWER:
        retVal = AppConstants.RACE_PREFER_NOT_TO_ANSWER_CLINICAL_VALUE;
        break;
      case AppConstants.RACE_NOT_COLLECTED:
        retVal = AppConstants.RACE_NOT_COLLECTED_CLINICAL_VALUE;
        break;
    }
    return retVal;
  }

  convertClinicalValuesToEntryValuesForRace(value: string): string {
    let retVal = null;
    switch (value) {
      case AppConstants.RACE_BLACK_CLINICAL_VALUE:
        retVal = AppConstants.RACE_BLACK;
        break;
      case AppConstants.RACE_EAST_SOUTHEAST_ASIAN_CLINICAL_VALUE:
        retVal = AppConstants.RACE_EAST_SOUTHEAST_ASIAN;
        break;
      case AppConstants.RACE_INDIGENOUS_CLINICAL_VALUE:
        retVal = AppConstants.RACE_INDIGENOUS;
        break;
      case AppConstants.RACE_LATINO_CLINICAL_VALUE:
        retVal = AppConstants.RACE_LATINO;
        break;
      case AppConstants.RACE_MIDDLE_EASTERN_CLINICAL_VALUE:
        retVal = AppConstants.RACE_MIDDLE_EASTERN;
        break;
      case AppConstants.RACE_SOUTH_ASIAN_CLINICAL_VALUE:
        retVal = AppConstants.RACE_SOUTH_ASIAN;
        break;
      case AppConstants.RACE_WHITE_CLINICAL_VALUE:
        retVal = AppConstants.RACE_WHITE;
        break;
      case AppConstants.RACE_OTHER_CLINICAL_VALUE:
        retVal = AppConstants.RACE_OTHER;
        break;
      case AppConstants.RACE_PREFER_NOT_TO_ANSWER_CLINICAL_VALUE:
        retVal = AppConstants.RACE_PREFER_NOT_TO_ANSWER;
        break;
      case AppConstants.RACE_NOT_COLLECTED_CLINICAL_VALUE:
        retVal = AppConstants.RACE_NOT_COLLECTED;
        break;
    }
    return retVal;
  }

  convertEntryValuesToClinicalDataAbsentReason(value: string): string {
    let retVal = null;
    switch (value) {
      case AppConstants.UNKNOWN_ENTRY_VALUE_CODE:
      case AppConstants.UNKNOWN_ENTRY_VALUE_TEXT:
        retVal = AppConstants.UNKNOWN_CLINICAL_VALUE;
        break;
      case AppConstants.NOT_APPLICABLE_ENTRY_VALUE:
      case AppConstants.NOT_APPLICABLE_DISPLAY_VALUE:
        retVal = AppConstants.NOT_APPLICABLE_CLINICAL_VALUE;
        break;
    }
    return retVal;
  }

  convertClinicalDataAbsentReasonToEntryValues(value: string, observationCode: string): string {
    let retVal = null;
    switch (value) {
      case AppConstants.UNKNOWN_CLINICAL_VALUE:
        if (
          observationCode === AppConstants.RACE_OBSERVATION_CODE ||
          observationCode === AppConstants.HEIGHT_OBSERVATION_CODE ||
          observationCode === AppConstants.WEIGHT_OBSERVATION_CODE ||
          observationCode === AppConstants.SERUM_CREATININE_OBSERVATION_CODE) {
          retVal = AppConstants.UNKNOWN_ENTRY_VALUE_TEXT;
        } else {
          retVal = AppConstants.UNKNOWN_ENTRY_VALUE_CODE;
        }
        break;
      case AppConstants.NOT_APPLICABLE_CLINICAL_VALUE:
        // #3475
        if (observationCode === AppConstants.URS_OBSERVATION_CODE ||
          observationCode === AppConstants.RMWT_OBSERVATION_CODE ||
          observationCode === AppConstants.PRIORITY_LEVEL_OBSERVATION_CODE) {
            retVal = AppConstants.NOT_APPLICABLE_DISPLAY_VALUE;
          } else {
            retVal = AppConstants.NOT_APPLICABLE_ENTRY_VALUE;
          }
        break;
    }
    return retVal;
  }

  convertEntryValuesToBoolean(value: string): boolean {
    let retVal = null;
    switch (value) {
      case AppConstants.ENTRY_VALUE_YES:
        retVal = true;
        break;
      case AppConstants.ENTRY_VALUE_NO:
        retVal = false;
        break;
    }
    return retVal;
  }

  convertBooleanValuesToEntryValues(valueBoolean: boolean): string {
    let retVal = null;
    if (valueBoolean) {
      retVal = AppConstants.ENTRY_VALUE_YES;
    } else {
      retVal = AppConstants.ENTRY_VALUE_NO;
    }
    return retVal;
  }
}
